import axios from 'axios'
import { foldersFor } from '@/helpers/providers'
import { eventBus } from '@/utils'
import appData from '@/helpers/app-data'

const baseUrl = '/list/folders'

// The API wants an array of Service Type IDs. Combine any duplicates
const compactServiceTypes = (serviceTypes) => {
  let stArray = serviceTypes.map((serviceType) => { return serviceType.id })
  return stArray.filter(function (value, index, self) {
    return self.indexOf(value) === index
  })
}

const state = {
  folders: appData.get('folders'),
  loading: false,
  pending: null,
  error: null
}

const getters = {
  folderCount () {
    return (Array.isArray(state.folders) && state.folders.length) || 0
  }
}

const mutations = {
  SET_LOADING (state, value) {
    state.loading = value
  },
  SET_FOLDERS (state, folders) {
    state.folders = folders
  },
  SET_PENDING (state, folder) {
    state.pending = folder
  },
  CREATE_FOLDER (state, folder) {
    if (state.folders) state.folders.push(folder)
    state.pending = null
  },
  UPDATE_FOLDER (state, folder) {
    let i = state.folders.map(f => f.id).indexOf(folder.id)
    state.folders.splice(i, 1, folder)
    state.pending = null
  }
}

const actions = {
  getFolders ({commit}) {
    commit('SET_LOADING', true)
    return axios.get(baseUrl)
      .then((response) => {
        commit('SET_FOLDERS', response.data)
        commit('SET_LOADING', false)
      })
  },
  createFolder ({commit, dispatch}, folder) {
    // Set to pending if the provider is already added or no service types are assigned
    if ((foldersFor(folder.provider).length && !folder.confirmed) || !folder.service_types || folder.service_types.length == 0) {
      commit('SET_PENDING', folder)
    } else {
      // will store the resource used to create the folder
      let resource
      let payload

      folder.service_type_ids = compactServiceTypes(folder.service_types)
      if (folder.confirmed) {
        delete folder.confirmed
      }
      if (folder.provider.id) {
        resource = baseUrl
        payload = folder
      // No provider ID - Add as a custom provider
      } else {
        resource = '/list/providers'
        payload = {
          name: folder.provider.name,
          url: folder.provider.url,
          service_type_ids: folder.service_type_ids
        }
      }
      return axios.post(resource, payload)
        .then((response) => {
          commit('CREATE_FOLDER', response.data)
          eventBus().$emit('notify', {
            group: 'main',
            type: 'success',
            title: 'Account Added',
            text: `${folder.provider.name} has been added to your Bills &amp; Accounts List.`
          })
          dispatch('recommendations/removeRemaining', folder.service_types, { root: true })
        })
    }
  },
  updateFolder ({commit, dispatch}, folder) {
    folder.service_type_ids = compactServiceTypes(folder.service_types)
    return axios.put(`${baseUrl}/${folder.id}`, folder)
      .then((response) => {
        commit('UPDATE_FOLDER', response.data)
        dispatch('recommendations/removeRemaining', folder.service_types, { root: true })
      })
  },
  cancelPendingFolder ({commit}) {
    commit('SET_PENDING', null)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/folders/index.js